import { render, staticRenderFns } from "./calendarEvent.vue?vue&type=template&id=7938902c&scoped=true&"
import script from "./calendarEvent.vue?vue&type=script&lang=js&"
export * from "./calendarEvent.vue?vue&type=script&lang=js&"
import style0 from "./calendarEvent.vue?vue&type=style&index=0&id=7938902c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7938902c",
  null
  
)

export default component.exports